var faGrid = {
  prefix: 'fass',
  iconName: 'grid',
  icon: [448, 512, ["grid-3"], "e195", "M0 32H128V160H0V32zM0 192H128V320H0V192zM128 352V480H0V352H128zM160 32H288V160H160V32zM288 192V320H160V192H288zM160 352H288V480H160V352zM448 32V160H320V32H448zM320 192H448V320H320V192zM448 352V480H320V352H448z"]
};

export { faGrid };
//# sourceMappingURL=index.js.map
